module.exports = __webpack_public_path__ + "img/img-house-back.02041c88.png";